import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppInstallBanner"] */ "/app/src/components/AppInstallBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/components/Providers.tsx");
